import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCheck } from '@fortawesome/free-solid-svg-icons/faCheck'
import { ReactNode } from 'react'
import { styled, theme } from '@/src/stitches.config'
import * as CheckboxPrimitive from '@radix-ui/react-checkbox'
import { TCheckboxStyleOptions } from '@/src/common/components/elements/Forms/types'

const StyledCheckbox = styled(CheckboxPrimitive.Root, {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: 4,
    backgroundColor: '$white',
    cursor: 'pointer',
    mr: 10,
    '.indicator': {
        display: 'flex',
        ai: 'center',
        jc: 'center',
    },
    variants: {
        variant: {
            primary: {
                border: `2px solid $primary`,
                "&[data-state='checked']": {
                    backgroundColor: '$primary',
                },
                '.indicator': {
                    color: '$white',
                },
                '&:focus': {
                    outline: `1px solid $primary`,
                },
            },
            secondary: {
                border: `2px solid $secondary`,
                "&[data-state='checked']": {
                    backgroundColor: '$secondary',
                },
                '.indicator': {
                    color: '$white',
                },
                '&:focus': {
                    outline: `1px solid $secondary`,
                },
            },
            whiteBgPrimary: {
                border: `2px solid $primary`,
                "&[data-state='checked']": {
                    backgroundColor: '$white',
                },
                '.indicator': {
                    color: '$primary',
                },
                '&:focus': {
                    outline: `1px solid $primary`,
                },
            },
            whiteBgSecondary: {
                border: `2px solid $secondary`,
                "&[data-state='checked']": {
                    backgroundColor: '$white',
                },
                '.indicator': {
                    color: '$secondary',
                },
                '&:focus': {
                    outline: `1px solid $secondary`,
                },
            },

            gradient: {
                background: `linear-gradient(white, white) padding-box, linear-gradient(73.53deg, ${theme.colors.primary} 18.47%, ${theme.colors.secondary} 78%) border-box`,
                border: '2px solid transparent',
                "&[data-state='checked']": {
                    border: 'unset',
                    background: `-webkit-linear-gradient(73.53deg, ${theme.colors.primary} 18.47%, ${theme.colors.secondary} 78%)`,
                },
                '.indicator': {
                    color: '$white',
                },
                '&:focus': {
                    outline: `1px solid $secondary`,
                },
            },
        },
        size: {
            sm: {
                width: 20,
                height: 20,
            },
            md: {
                width: 25,
                height: 25,
            },
            lg: {
                width: 30,
                height: 30,
            },
        },
    },
})

const CheckboxWrapper = styled('div', {
    alignItems: 'center',
    display: 'flex',
})

type TCheckboxProps = TCheckboxStyleOptions & {
    id: string
    children: ReactNode
    setCheckState: Function
}

export const CheckboxInputWithChildren = ({
    id,
    children,
    checkboxVariant = 'secondary',
    checkboxSize = 'md',
    setCheckState,
}: TCheckboxProps) => {
    return (
        <CheckboxWrapper>
            <StyledCheckbox
                id={id}
                variant={checkboxVariant}
                onCheckedChange={(checked) => setCheckState(checked)}
                size={checkboxSize}
            >
                <CheckboxPrimitive.Indicator className={'indicator'}>
                    <FontAwesomeIcon icon={faCheck} />
                </CheckboxPrimitive.Indicator>
            </StyledCheckbox>
            <>{children}</>
        </CheckboxWrapper>
    )
}
